module.exports = __webpack_public_path__ + "static/media/summer-min.15142b89.jpeg";